<template>
  <div>
    <div :key="timer" class="swiperMain">
      <div class="swiperMainTitle">
        <span class="swiperMainTitleSpan" v-if="title">{{ title }}</span>
      </div>
      <div class="swiperWhiteLine"></div>
      <div class="swiperMainContent">
        <span class="swiperMainContentSpan" v-if="content">{{ content }}</span>
      </div>
      <div class="swiperMainBtnDiv">
        <Button class="swiperMainBtn" @click="goLink" ghost>查看详情</Button>
      </div>
    </div>
    <Carousel autoplay v-model="value1" loop :autoplay-speed="time" @on-change="getIndex">
      <CarouselItem v-for="(item, index) in imgList" :key="index">
        <div class="demo-carousel">
          <div class="carouselImgDiv">
            <!-- <div style="width: 100%; height: 70vh;position:absolute;z-index:997;background:rgba(0,0,0,0.6)"></div> -->
            <img :src="item.imgUrl" alt="carouselImg" class="carouselImg" />
          </div>
        </div>
      </CarouselItem>
    </Carousel>
  </div>
</template>
<script>
// import categoryChooseIdsVue from '../../../choose/category-choose-ids.vue';
export default {
  data() {
    return {
      timer: '',
      value1: 0,
      time: 6000,
      imgList: [],
      content: '',
      nowIndex: 0,
      title: '',
      categoryId: '',
      topicId: ''
    };
  },
  // computed: {
  //   // 计算属性的 getter
  //   title: function () {
  //     return this.imgList[this.nowIndex].content
  //   }
  // },
  // watch: {
  //   nowIndex (val) {
  //     this.title = this.imgList[this.nowIndex].content
  //   }
  // },
  methods: {
    getHomePageSlideList() {
      this.$api['ql/getHomePageSlideList']({}).then(res => {
        this.imgList = res;
        this.title = this.imgList[0].title;
        this.content = this.imgList[0].content;
      });
    },
    getIndex(old, value) {
      this.nowIndex = value;
      this.title = this.imgList[value].title;
      this.content = this.imgList[value].content;
      this.topicId = this.imgList[value].topicId;
      this.categoryId = this.imgList[value].categoryId;
      this.timer = new Date().getTime();
    },
    goLink() {
      if (this.topicId === '' && this.categoryId === '') {
        this.topicId = this.imgList[0].topicId;
        this.categoryId = this.imgList[0].categoryId;
      }
      let params = {
        categoryId: this.categoryId,
        topicId: this.topicId,
      };
      this.$router.push({
        name: 'product',
        params: params
      });
    }
  },
  mounted() {
    this.getHomePageSlideList();
    this.timer = new Date().getTime();
  }
};
</script>
<style lang="less">
//PC或中大型笔记本设备
@media screen and (min-width: 1201px) {
.swiperMain {
  text-align:center;
  width:50%;
  position: absolute;
  left: 6%;
  top: 26vh;
  color:#fff;
  z-index: 998;
}
.swiperMainTitle {
  color:#fff;
  font-weight: normal;
  text-align:left;
}
.swiperMainTitleSpan {
  font-size: 48px;
  font-family: Adobe Heiti Std;
}
.swiperWhiteLine {
  width: 700px;
  height: 1px;
  background: #fff;
}
.swiperMainContent {
  word-break:break-all;
  word-wrap:break-word;
  font-size: 16px;
  font-weight: normal;
  text-align:left;
}
.swiperMainContentSpan {
  font-size: 24px;
}
.swiperMainBtnDiv {
  margin-top: 20px;
  float:left;
}
.swiperMainBtn {
  width:200px;
  height:54px;
  font-size: 24px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
}
.carouselImgDiv {
  width: 100%;
  height: 100%;
}
.carouselImg {
  width:100%;
  height:70vh;
}
}

//中小型笔记本或大平板
@media screen and (min-width: 980px) and (max-width: 1200px) {
.swiperMain {
  text-align:center;
  width:50%;
  position: absolute;
  left: 6%;
  top: 26vh;
  color:#fff;
  z-index: 998;
}
.swiperMainTitle {
  color:#fff;
  font-weight: normal;
  text-align:left;
}
.swiperMainTitleSpan {
  font-size: 40px;
  font-family: Adobe Heiti Std;
}
.swiperWhiteLine {
  width: 100%;
  height: 1px;
  background: #fff;
}
.swiperMainContent {
  word-break:break-all;
  word-wrap:break-word;
  font-size: 16px;
  font-weight: normal;
  text-align:left;
}
.swiperMainContentSpan {
  font-size: 24px;
}
.swiperMainBtnDiv {
  margin-top: 20px;
  float:left;
}
.swiperMainBtn {
  width:200px;
  height:54px;
  font-size: 24px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
}
.carouselImgDiv {
  width: 100%;
  height: 100%;
}
.carouselImg {
  width:100%;
  height:70vh;
}
}

//中型平板或小型笔记本
@media screen and (orientation: portrait){
  .swiperMain {
  text-align:center;
  width:50%;
  position: absolute;
  left: 6%;
  top: 26vh;
  color:#fff;
  z-index: 998;
}
.swiperMainTitle {
  color:#fff;
  font-weight: normal;
  text-align:left;
}
.swiperMainTitleSpan {
  font-size: 30px;
  font-family: Adobe Heiti Std;
}
.swiperWhiteLine {
  width: 100%;
  height: 1px;
  background: #fff;
}
.swiperMainContent {
  word-break:break-all;
  word-wrap:break-word;
  font-size: 16px;
  font-weight: normal;
  text-align:left;
}
.swiperMainContentSpan {
  font-size: 24px;
}
.swiperMainBtnDiv {
  margin-top: 20px;
  float:left;
}
.swiperMainBtn {
  width:200px;
  height:54px;
  font-size: 24px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
}
.carouselImgDiv {
  width: 100%;
  height: 100%;
}
.carouselImg {
  width:100%;
  height:45vh;
}
}

// 手机或小平板
@media screen and (max-width: 767px) {
  .swiperMain {
    text-align: left;
    width: 85%;
    position: absolute;
    left: 7.5%;
    top: 15%;
    color: #fff;
    z-index: 2;
  }

  .swiperMainTitle {
    color: #fff;
    font-weight: normal;
    text-align: left;
    margin-bottom: 10px;
  }

  .swiperMainTitleSpan {
    font-size: 20px;
    font-family: Adobe Heiti Std;
    line-height: 1.4;
  }

  .swiperWhiteLine {
    width: 40px;
    height: 2px;
    background: #fff;
    margin: 10px 0;
  }

  .swiperMainContent {
    word-break: break-all;
    word-wrap: break-word;
    text-align: left;
    margin: 10px 0;
  }

  .swiperMainContentSpan {
    font-size: 14px;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .swiperMainBtnDiv {
    display: none;
  }

  .carouselImgDiv {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #1e293b;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.1));
      z-index: 1;
    }
  }

  .carouselImg {
    width: 100%;
    height: 56.25vw; /* 16:9的宽高比 */
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .demo-carousel {
    width: 100%;
    position: relative;
    background: #1e293b;
  }

  .ivu-carousel-dots {
    bottom: 10px;
    z-index: 2;
  }

  .ivu-carousel-dots-inside {
    bottom: 15px !important;
  }

  .ivu-carousel-dots li button {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.6);
  }

  .ivu-carousel-dots li.ivu-carousel-active button {
    width: 12px;
    background: #fff;
  }
}

// 超小屏幕手机
@media screen and (max-width: 375px) {
  .swiperMain {
    top: 12%;
    width: 90%;
    left: 5%;
  }

  .swiperMainTitleSpan {
    font-size: 16px;
    line-height: 1.3;
  }

  .swiperMainContentSpan {
    font-size: 12px;
    line-height: 1.4;
    -webkit-line-clamp: 2;
  }

  .swiperMainBtnDiv {
    display: none;
  }

  .swiperMainBtn {
    width: 100px;
    height: 32px;
    font-size: 12px;
  }

  .carouselImg {
    height: 66.67vw; /* 3:2的宽高比 */
  }

  .ivu-carousel-dots {
    bottom: 10px;
  }

  .ivu-carousel-dots li button {
    width: 6px;
    height: 6px;
  }

  .ivu-carousel-dots li.ivu-carousel-active button {
    width: 12px;
  }
}
</style>
